import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'bytesToMegaBytes'
})
export class BytesToMegabytesPipe implements PipeTransform {

    transform(bytes: number): string {
        let val:number = bytes / 1000;
        val = val / 1000;
        return Math.round( val ).toLocaleString();
    }

}


// WEBPACK FOOTER //
// ./src/app/pipes/bytes-to-megabytes.pipe.ts